module.exports = __webpack_public_path__ + "static/media/ser_sur_map.35daa497.png";